import styled from "@emotion/styled"
import { useState } from "react"

const StarRow = styled.div`
  display: flex;
  gap: 0.25rem;
  margin: 0.25rem 0 1rem 0;
`

const Star = styled.span<{ active: boolean; disabled?: boolean }>`
  font-size: 1.5rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  color: ${({ active }) => (active ? "#f5b301" : "#ccc")};
  transition: color 0.15s ease;
  user-select: none;

  &:hover {
    color: ${({ disabled }) => (disabled ? undefined : "#f5b301")};
  }
`

interface V2L2StarRatingProps {
  value: number
  onChange: (v: number) => void
  disabled?: boolean
}

export const V2L2StarRating = ({ value, onChange, disabled }: V2L2StarRatingProps) => {
  const [hover, setHover] = useState<number | null>(null)

  return (
    <StarRow>
      {[1, 2, 3, 4, 5].map((star) => {
        const active = hover !== null ? star <= hover : star <= value
        return (
          <Star
            key={star}
            active={active}
            disabled={disabled}
            onMouseEnter={() => !disabled && setHover(star)}
            onMouseLeave={() => !disabled && setHover(null)}
            onClick={() => !disabled && onChange(star)}
          >
            ★
          </Star>
        )
      })}
    </StarRow>
  )
}
